<template>
  <div id="organization_outer" v-if="introduceData != null">
    <img :src="introduceData.organization" style="width: 80%;height: auto;">

    <div style="width: 80%;text-align: left;display: inline-block;margin-top: 30px;" v-html="desc">

    </div>
  </div>
</template>

<script>
export default {
  name: "OrganizationDetail",
  data() {
    return {
      title: '组织架构',
      desc: '',
    }
  },
  mounted() {
    const file = this.loadFile('../../static/shl_organization_member_intro.html');
    this.desc = file;
  },
  computed: {
    introduceData() {
      return this.$store.state.introduceData;
    },
  }
}
</script>

<style scoped>

  #organization_outer {
    width: 100%;
    text-align: center;
  }

  #organization_outer > img {
    width: 40px;
    height: 80px;
   }

</style>



// WEBPACK FOOTER //
// src/components/introduce/OrganizationDetail.vue